import RmService from '../../../services/rm/rmService';
const api = new RmService()
const state = {
  user_rm:null,
  user_rm_loading:false,
  caderno_formando:[],
  caderno_formando_loading:false,
  caderno_concluintes:[],
  caderno_concluintes_loading:false,
  info_aluno:{},
  info_aluno_loading:false,
};
const getters = {
  StateUserRm: state => state.user_rm,
  StateUserRmLoading: state => state.user_rm_loading,
  StateInfoAluno: state => state.info_aluno,
  StateInfoAlunoLoading: state => state.info_aluno_loading,
  StateCadernoFormando: state => state.caderno_formando,
  StateCadernoFormandoLoading: state => state.caderno_formando_loading,
  StateCadernoConcluintes: state => state.caderno_concluintes,
  StateCadernoConcluintesLoading: state => state.caderno_concluintes_loading,
};
const mutations = {
  SetUserRm(state, value){state.user_rm = value},
  SetUserRmLoading(state, value){state.user_rm_loading = value},
  SetInfoAluno(state, value){state.info_aluno = value},
  SetInfoAlunoLoading(state, value){state.info_aluno_loading = value},
  SetCadernoFormando(state, value){state.caderno_formando = value},
  SetCadernoFormandoLoading(state, value){state.caderno_formando_loading = value},
  SetCadernoConcluintes(state, value){state.caderno_concluintes = value},
  SetCadernoConcluintesLoading(state, value){state.caderno_concluintes_loading = value},
};
const actions = {
    async GetUserRm({commit}, params) {
      commit('SetUserRmLoading', true)
      try{
          let response = await api.get_user_rm(params)
          commit('SetUserRm', response.data)
        }catch(error){
          commit('SetUserRm', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum usuário encontrado!',
              tag: 'warn',
              timeout: '4000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetUserRmLoading', false)
    },
    async GetInfoAluno({commit}, params) {
      commit('SetInfoAlunoLoading', true)
      try{
          let response = await api.get_info_aluno(params)
          commit('SetInfoAluno', response.data)
        }catch(error){
          commit('SetInfoAluno', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Aluno não encontrado!',
              tag: 'warn',
              timeout: '5000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async AtivaUserAluno({commit, dispatch}, params) {
      commit('SetInfoAlunoLoading', true)
      // console.log('params ativaUserAluno', params)
      try{
          let response = await api.ativa_aluno(params)
          if (response.status == 200){
            commit("setAlerts", [ {
              message: 'Aluno ativado com sucesso!',
              tag: 'success',
              timeout: '3000',
              title: 'Ativado'
            } ])
            dispatch('GetInfoAluno', {ra:params.user})
          }else{
            commit("setAlerts", [ {
              message: 'Falha ao ativar aluno!',
              tag: 'warn',
              timeout: '1000',
              title: 'Erro: '+response.status
            } ])
          }
        }catch(error){
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Aluno não encontrado!',
              tag: 'warn',
              timeout: '5000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async GetCadernoFormando({commit}, params) {
      commit('SetCadernoFormandoLoading', true)
      try{
          let response = await api.get_caderno_formando(params)
          commit('SetCadernoFormando', response.data)
        }catch(error){
          commit('SetCadernoFormando', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum registro encontrado!',
              tag: 'warn',
              timeout: '4000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetCadernoFormandoLoading', false)
    },
    async GetCadernoConcluintes({commit}, params) {
      commit('SetCadernoConcluintesLoading', true)
      try{
          let response = await api.get_caderno_concluintes(params)
          commit('SetCadernoConcluintes', response.data)
        }catch(error){
          commit('SetCadernoConcluintes', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum registro encontrado!',
              tag: 'warn',
              timeout: '4000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetCadernoConcluintesLoading', false)
    },
    async GetAlunoImage({commit}, matricula) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.get_aluno_imagem(matricula)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum aluno encontrado!',
              tag: 'warn',
              timeout: '6000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async GetPletivosEnturmacao({commit}) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.pletivos_enturmar()
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Falha ao carregar períodos letivos!',
              tag: 'warn',
              timeout: '6000',
              title: 'Falha de Per. Letivos'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async GetPletivos({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.pletivos(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Falha ao carregar períodos letivos!',
              tag: 'warn',
              timeout: '6000',
              title: 'Falha de Períodos letivos'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async GetScursos({commit}, params) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.scursos(params)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Falha ao carregar cursos!',
              tag: 'warn',
              timeout: '6000',
              title: 'Falha de Scursos'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async GetTurmasEnturmacao({commit}, params) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.sturma_enturmar(params)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Falha ao carregar turmas!',
              tag: 'warn',
              timeout: '6000',
              title: 'Falha de Sturma'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async GetListaRAEnturmacao({commit}, params) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.lista_ra_enturmar(params)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Falha ao carregar Ra`s!',
              tag: 'warn',
              timeout: '6000',
              title: 'Falha de Lista RA'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetInfoAlunoLoading', false)
    },
    async Enturmar({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.enturmar(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async ListProUniComplementar({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.lista_prouni_complementar(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async SetProUniComplementar({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.set_prouni_complementar(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async SetDataLancamento({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.set_data_lancamentos(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async SetMigracaoBolsas({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.set_migracao_bolsas(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async SetAtualizaParcela({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.set_atualiza_parcela(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
        console.log(error)
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async SetProUni50({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.lista_prouni_complementar(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async SetNFRejeitada({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.set_nf_rejeitada(data)
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
    },
    async SetAlunoImage({commit}, data) {
      commit('SetInfoAlunoLoading', true)
      try{
        let response = await api.set_aluno_imagem(data)
        commit("setAlerts", [ {
          message: `Aluno atualizado com sucesso!`,
          tag: 'success',
          timeout: '7000',
          title: 'Atualização de foto'
        } ])
        commit('SetInfoAlunoLoading', false)
        return response
      }catch(error){
          commit('SetInfoAlunoLoading', false)
          commit("setAlerts", [ error.toast_message ])
      }
      commit('SetInfoAlunoLoading', false)
    },
};
export default {
  state,
  getters,
  actions,
  mutations
};